module.exports = __webpack_public_path__ + "img/switched-on.a480cf59.svg";